import { ReferenceUpload } from './referenceUpload';
import { VariantUpload } from './variantUpload';
import { BulkUpload } from './bulkUpload';

export class BulkUploadReferenceVariants extends BulkUpload {

  Reference: ReferenceUpload;
  Variants: VariantUpload[];
}
